@defer (when user) {
  <article class="content-container mb-1">
    <header>
      <h1>Invite User</h1>
    </header>

    <div class="details-grid">
      <div>Full Name</div>
      <div>Email address</div>
      <div class="is-tracked" [title]="isTrackable ? 'Included in engagement' : 'NOT included in engagement'" tooltipPosition="top">Engagement</div>
      <div>
        <input type="name" class="fourd" [(ngModel)]="invite.name" placeholder="Firstname Lastname" [class.in-error]="invite.name?.length < 2 && inError" [title]="invite.name?.length < 2 && inError ? 'Enter a valid name (2 or more characters)' : ''" />
      </div>
      <div>
        <input type="email" class="fourd" [(ngModel)]="invite.email" placeholder="person@email.com" [class.in-error]="invite.email?.length < 10 && inError" [title]="invite.email?.length < 10 && inError ? 'Enter a valid email' : ''" />
      </div>
      <div>
        <span (click)="isTrackable = !isTrackable" class="can-click">
          <span class="mdi" [class.mdi-checkbox-marked-outline]="isTrackable" [class.mdi-checkbox-blank-outline]="!isTrackable"></span> <span>{{ isTrackable ? ' Tracked in engagement' : 'Not tracked in engagement' }}</span>
        </span>
      </div>
    </div>

    <div class="mt-1">
      <div class="mb-1">Notes</div>
      <textarea rows="2" class="fourd" name="notes" [(ngModel)]="invite.notes" placeholder="Optional"></textarea>
    </div>

    <h1>Modules access</h1>

    <div class="select-box">
      <label
        >Modules
        @if (totals.modules) {
          <small>{{ totals.modules }} selected</small>
        }
        @if (totals.modules === 0) {
          <b style="color: red">You must select at least one module</b>
        }
      </label>
      <div class="module-list">
        @for (module of moduleList; track module) {
          <div [class.active]="module.selected" (click)="toggleModule(module)">
            <span tooltipPosition="top" title="{{ module.tooltip }}">
              @switch (module.label) {
                @case ('profiling') {
                  floorplans
                }
                @default {
                  {{ module.label }}
                }
              }
            </span>
          </div>
        }
      </div>
    </div>

    <h1>Site access</h1>

    <div class="select-box" #site [class.in-error]="siteSelectedCount() === 0 && inError">
      <app-toolbar>
        <div class="left">
          Sites <small>{{ siteSelectedCount() }} / {{ siteList().length }}</small>
          @if (siteSelectedCount() === 0) {
            <b style="color: red"> Select at least one site</b>
          }
        </div>
        <div class="right">
          <app-button label="Toggle selected" (click)="toggleSites()"></app-button>
        </div>
      </app-toolbar>

      <div class="module-list">
        @for (site of siteList(); track site) {
          <div [class.active]="site.selected">
            <span (click)="toggleSite(site)" tooltipPosition="top" [title]="site.tooltip" [escape]="false">{{ site.label }}</span>
          </div>
        }
      </div>
    </div>

    <h1>Auto Expiration</h1>

    <div class="other-options">
      <div class="expires">
        <label>Expires (optional) </label>
        <div class="user-expire-message">
          @if (expiresAt) {
            <div>User expires on {{ expiresAt | date: 'dd/MM/yyyy' }}</div>
            <div><app-button size="small" label="Cancel" icon="mdi mdi-close" styleClass="p-button-outlined p-button-secondary" (click)="expiresAt = null; isExpiresEnabled = false" /></div>
          } @else {
            This user will not expire, select a date below to expire the user on that date.
          }
        </div>
        <div class="mt-1">
          @if (isExpiresEnabled) {
            <app-calendar [value]="expiresAt" (onSelect)="expireSelected($event)" />
          } @else {
            <app-button label="Enable Expiration" (click)="isExpiresEnabled = true"></app-button>
          }
        </div>
      </div>
    </div>

    <div class="buttons mb-1">
      <div class="text-right">
        <app-button label="Cancel" icon="mdi mdi-close" styleClass="p-button-outlined p-button-secondary mr-1" (click)="cancel()" class="mr-1" />
        <app-button label="Invite" icon="mdi mdi-card-account-mail-outline" (click)="inviteUser()" [isCTA]="true" />
      </div>
    </div>
  </article>
} @placeholder (minimum 100ms) {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}

@if (isInviting) {
  <app-dialog [canInteract]="false" [dimensions]="{ width: 210, height: 72 }">
    <p>Inviting user, please wait...</p>
  </app-dialog>
}
